import { render, staticRenderFns } from "./sanctuary2023.vue?vue&type=template&id=bdf8de0a&scoped=true&"
import script from "./sanctuary2023.vue?vue&type=script&lang=js&"
export * from "./sanctuary2023.vue?vue&type=script&lang=js&"
import style0 from "./sanctuary2023.vue?vue&type=style&index=0&id=bdf8de0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf8de0a",
  null
  
)

export default component.exports